import { Link } from "react-router-dom";
import { useT } from "@/i18n/I18nProvider";

export default function NotFound() {
  const t = useT();
  return (
    <section className="container-x py-32 text-center" data-testid="not-found">
      <span className="eyebrow justify-center">404</span>
      <h1 className="mt-5 text-4xl sm:text-5xl font-bold">{t("We couldn't find that page")}</h1>
      <p className="mt-4 text-[var(--muted)]">{t("Sorry, the page you were looking for doesn't exist or has been moved.")}</p>
      <Link to="/" className="btn btn-blue mt-8">{t("Back to home")}</Link>
    </section>
  );
}
